import { INTERNAL_HOST } from '@/commonConst';
import useTrialOptions from '@/helpers/commonHooks/useTrialOptions';
import { useTranslation } from 'react-i18next';
import ZH_TRANSLATION from '@/i18n/locales/zh/translation'
import { useNormOptions } from '@/helpers/commonHooks/useNormOptions';
import { CREATIVE_DIAGNOSIS_OUTPUT_LANGUAGE_OPTIONS } from '@/helpers/outputLanguage'


export function useStepOptions(
  rawOutputLanguageOptions = CREATIVE_DIAGNOSIS_OUTPUT_LANGUAGE_OPTIONS
) {
  const { t } = useTranslation()
  const { COUNTRY_OPTIONS } = useTrialOptions()
  const TARGET_MARKET_OPTIONS = COUNTRY_OPTIONS
  const NORM_OPTIONS = useNormOptions()
  const GENDER_OPTIONS = [
    {
      value: 'male',
      label: t('dashboard.projectCreatePage.genderSelect.male'),
    },
    {
      value: 'female',
      label: t('dashboard.projectCreatePage.genderSelect.female'),
    },
    {
      value: 'all',
      label: t('dashboard.projectCreatePage.genderSelect.all'),
    },
  ]

  const INDUSTRY_CATEGORY_OPTIONS = [
    /** 食品饮料 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.foodAndBeverageCategory'),
      value: t('dashboard.projectCreatePage.industryCategorySelect.foodAndBeverageCategory'),
      children: [
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.packagedFood,
          label: t('dashboard.projectCreatePage.industryCategorySelect.packagedFood'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.confectionery,
          label: t('dashboard.projectCreatePage.industryCategorySelect.confectionery'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.frozenMeals,
          label: t('dashboard.projectCreatePage.industryCategorySelect.frozenMeals'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.fastFood,
          label: t('dashboard.projectCreatePage.industryCategorySelect.fastFood'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.beverage,
          label: t('dashboard.projectCreatePage.industryCategorySelect.beverage'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.alcohol,
          label: t('dashboard.projectCreatePage.industryCategorySelect.alcohol'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.dairy,
          label: t('dashboard.projectCreatePage.industryCategorySelect.dairy'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.grainAndSeasoning,
          label: t('dashboard.projectCreatePage.industryCategorySelect.grainAndSeasoning'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.beverageMixes,
          label: t('dashboard.projectCreatePage.industryCategorySelect.beverageMixes'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.freshProduce,
          label: t('dashboard.projectCreatePage.industryCategorySelect.freshProduce'),
        },
        {
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherFoodAndBeverage,
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherFoodAndBeverage'),
        },
      ],
    },
    /** 3C数码 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.consumerElectronicsCategory'),
      // en: Consumer Electronics
      label: t('dashboard.projectCreatePage.industryCategorySelect.consumerElectronicsCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.mobilePhone'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.mobilePhone,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.computer'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.computer,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.smartDevice'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.smartDevice,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.phoneAccessories'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.phoneAccessories,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.computerAccessories'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.computerAccessories,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.software'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.software,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.camera'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.camera,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.officeSupplies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.officeSupplies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherConsumerElectronics'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherConsumerElectronics,
        },
      ],
    },
    /** 医药保健 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.pharmaceuticalsAndHealthCareCategory'),
      // Pharmaceuticals & Health Care
      value: t('dashboard.projectCreatePage.industryCategorySelect.pharmaceuticalsAndHealthCareCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otcMedicine'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otcMedicine,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.prescriptionDrugs'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.prescriptionDrugs,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.healthSupplements'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.healthSupplements,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.pharmaceuticalCompanies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.pharmaceuticalCompanies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.medicalDevices'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.medicalDevices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.medicalServices'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.medicalServices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.pharmacy'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.pharmacy,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherPharmaceuticalsAndHealthCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherPharmaceuticalsAndHealthCare,
        },
      ],
    },
    /** 美容护理 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.beautyAndPersonalCareCategory'),
      // Beauty & Personal Care & Cleaning supplies
      label: t('dashboard.projectCreatePage.industryCategorySelect.beautyAndPersonalCareCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.hairCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.hairCare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.womenSkincare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.womenSkincare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.homeCleaning'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.homeCleaning,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.bodyCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.bodyCare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.feminineCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.feminineCare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.oralCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.oralCare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.menSkincare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.menSkincare,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.makeup'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.makeup,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.fragrances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.fragrances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.beautyServices'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.beautyServices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherBeautyAndPersonalCare'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherBeautyAndPersonalCare,
        },
      ],
    },
    /** 母婴用品 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.maternalAndInfantProductsCategory'),
      // Maternal & Infant Products
      label: t('dashboard.projectCreatePage.industryCategorySelect.maternalAndInfantProductsCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.babyFood'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.babyFood,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.babyCareEssentials'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.babyCareEssentials,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.babyToys'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.babyToys,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherMaternalAndInfantProducts'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherMaternalAndInfantProducts,
        },
      ],
    },
    /** 网络通讯 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.networkAndCommunicationCategory'),
      // Network & Communication
      label: t('dashboard.projectCreatePage.industryCategorySelect.networkAndCommunicationCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.mobileCarriers'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.mobileCarriers,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.internetProviders'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.internetProviders,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.telecomEquipment'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.telecomEquipment,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherNetworkAndCommunication'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherNetworkAndCommunication,
        },
      ],
    },
    /** 旅游住宿 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.travelAndAccommodationCategory'),
      // Travel/ Accommodation
      label: t('dashboard.projectCreatePage.industryCategorySelect.travelAndAccommodationCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.localTourism'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.localTourism,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.bookingPlatform'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.bookingPlatform,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.hotels'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.hotels,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.airlines'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.airlines,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.airport'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.airport,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherTravelAndAccommodation'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherTravelAndAccommodation,
        },
      ],
    },
    /** 交通运输 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.vehiclesCategory'),
      // Vehicles
      label: t('dashboard.projectCreatePage.industryCategorySelect.vehiclesCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.motorVehicleProductsAndServices'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.motorVehicleProductsAndServices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.carBrands'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.carBrands,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.dealerships'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.dealerships,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.carFinance'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.carFinance,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.evCar'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.evCar,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.motorcycle'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.motorcycle,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.onlineUsedCarMarketplace'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.onlineUsedCarMarketplace,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.carRentalPlatform'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.carRentalPlatform,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.travelNavigation'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.travelNavigation,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.bicycle'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.bicycle,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherVehicles'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherVehicles,
        },
      ],
    },
    /** 家用电器 */
    {
      value: t('dashboard.projectCreatePage.industryCategorySelect.householdAppliancesCategory'),
      // Household Appliances
      label: t('dashboard.projectCreatePage.industryCategorySelect.householdAppliancesCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.majorAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.majorAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.healthAndPersonalCareAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.healthAndPersonalCareAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.majorKitchenAndBathAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.majorKitchenAndBathAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.smallKitchenAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.smallKitchenAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.environmentalAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.environmentalAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.cleaningAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.cleaningAppliances,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherHouseholdAppliances'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherHouseholdAppliances,
        },
      ],
    },
    /** 零售和服務 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.retailAndServiceCategory'),
      // Retail & Service
      value: t('dashboard.projectCreatePage.industryCategorySelect.retailAndServiceCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.onlineRetailEcommerce'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.onlineRetailEcommerce,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.departmentStores'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.departmentStores,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.lifeServices'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.lifeServices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.retailServicesAndDelivery'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.retailServicesAndDelivery,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.supermarkets'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.supermarkets,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherRetailAndService'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherRetailAndService,
        },
      ],
    },
    /** 服装服饰 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.apparelCategory'),
      // Clothing & Accessories
      value: t('dashboard.projectCreatePage.industryCategorySelect.apparelCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.footwear'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.footwear,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.clothing'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.clothing,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.watchesWatchRetail'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.watchesWatchRetail,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.jewelry'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.jewelry,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.bags'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.bags,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.eyewearOpticalStores'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.eyewearOpticalStores,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherClothingAndAccessories'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherClothingAndAccessories,
        },
      ],
    },
    /** 家居家装 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.homeImprovementAndFurnishingsCategory'),
      // Home Improvement & Furnishings
      value: t('dashboard.projectCreatePage.industryCategorySelect.homeImprovementAndFurnishingsCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.homeFurnishing'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.homeFurnishing,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.homeImprovement'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.homeImprovement,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherHomeImprovementAndFurnishings'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherHomeImprovementAndFurnishings,
        },
      ],
    },
    /** 金融/理财/保险 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.financialAndInsuranceCategory'),
      // Financial & Insurance
      value: t('dashboard.projectCreatePage.industryCategorySelect.financialAndInsuranceCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.bank'), // Bank
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.bank,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.fintech'), // FinTech
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.fintech,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.investmentAndFinancialServices'), // Investment & Financial Services
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.investmentAndFinancialServices,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.insurance'), // Insurance
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.insurance,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherFinancialAndInsurance'), // Other Financial & Insurance
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherFinancialAndInsurance,
        },
      ],
    },
    /** 休闲娱乐 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.entertainmentAndLeisureCategory'),
      // Entertainment & Leisure
      value: t('dashboard.projectCreatePage.industryCategorySelect.entertainmentAndLeisureCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.socialApp'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.socialApp,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.toysAndDolls'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.toysAndDolls,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.concerts'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.concerts,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.events'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.events,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.movies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.movies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.themeParks'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.themeParks,
        },
        /** 国内环境，不展示【博彩】行业 */
        ...(
          INTERNAL_HOST.includes(location.hostname)
            ? []
            : [{
              label: t('dashboard.projectCreatePage.industryCategorySelect.gambling'),
              value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.gambling,
            }]
        ),
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.onlineGaming'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.onlineGaming,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.tvChannels'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.tvChannels,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherEntertainmentAndLeisure'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherEntertainmentAndLeisure,
        },
      ],
    },
    /** 工业农业 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.industrialAndAgriculturalCategory'),
      // Industrial & Agricultural
      value: t('dashboard.projectCreatePage.industryCategorySelect.industrialAndAgriculturalCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.industrialSupplies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.industrialSupplies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.agriculturalSupplies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.agriculturalSupplies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherIndustrialAndAgricultural'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherIndustrialAndAgricultural,
        },
      ],
    },
    /** 宠物生活 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.petLifeCategory'),
      // Pet Industry
      value: t('dashboard.projectCreatePage.industryCategorySelect.petLifeCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.petFood'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.petFood,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.petSupplies'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.petSupplies,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherPetLife'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherPetLife,
        },
      ],
    },
    /** 教育与学习 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.educationAndLearningCategory'),
      // Education & Learning
      value: t('dashboard.projectCreatePage.industryCategorySelect.educationAndLearningCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.onlineLearning'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.onlineLearning,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.schools'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.schools,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.skillCourses'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.skillCourses,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.tutoring'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.tutoring,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.universities'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.universities,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherEducationAndLearning'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherEducationAndLearning,
        },
      ]
    },
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.communityAndPublicServiceCategory'),
      // Community & Public Service
      value: t('dashboard.projectCreatePage.industryCategorySelect.communityAndPublicServiceCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.charityCampaigns'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.charityCampaigns,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.ngoAds'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.ngoAds,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherCommunityAndPublicService'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherCommunityAndPublicService,
        },
      ]
    },
    /** 其他 */
    {
      label: t('dashboard.projectCreatePage.industryCategorySelect.otherCategory'),
      // Other Categories
      value: t('dashboard.projectCreatePage.industryCategorySelect.otherCategory'),
      children: [
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.governmentAdvertising'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.governmentAdvertising,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.realEstateAdvertising'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.realEstateAdvertising,
        },
        {
          label: t('dashboard.projectCreatePage.industryCategorySelect.otherAdvertising'),
          value: ZH_TRANSLATION.dashboard.projectCreatePage.industryCategorySelect.otherAdvertising,
        },
      ],
    },
  ]

  const OUTPUT_LANGUAGE_OPTIONS: Array<{ label: string, value: ProjectModels.UseLanguage }> = [
    ...rawOutputLanguageOptions.map((option) => ({
      label: t(option.labelKey),
      value: option.value,
    })),
  ]

  return {
    GENDER_OPTIONS,
    TARGET_MARKET_OPTIONS,
    NORM_OPTIONS,
    INDUSTRY_CATEGORY_OPTIONS,
    OUTPUT_LANGUAGE_OPTIONS,
  }
}
